import { Localized } from "@fluent/react";
import { Alert, Button, CardContent, CardHeader, Stack, TextField, Typography } from "@mui/material";
import FormScreen from "./FormScreen";
import { useNavigate } from "react-router-dom";

export enum Feedback {
	RejectedNetwork,
	RejectedBug,
	RejectedInvalidEmail,
	Accepted,
}

export interface NewAccountRecoveryRequestUIProps {
	pending: boolean,
	feedback?: Feedback,
	email: string,
	setEmail(email: string): void,
	onSubmit?: () => void,
}

export default function ForgotCredentialsPageUI(props: NewAccountRecoveryRequestUIProps) {
	const navigate = useNavigate();
	return <FormScreen
		pending={props.pending}
		header={
			<Localized id="account-recovery-create-header" attrs={{ title: true, subheader: true }}>
				<CardHeader />
			</Localized>
		}
		feedback={props.feedback && <FormFeedback feedback={props.feedback} />}
		onSubmit={props.onSubmit}
	>
		<CardContent>
			<Localized id="account-recovery-create-email" attrs={{ label: true }}>
				<TextField
					type="email"
					value={props.email}
					onChange={e => props.setEmail(e.target.value)}
					disabled={props.pending}
					variant="outlined"
					margin="normal"
					required
					fullWidth />
			</Localized>
			<Localized
				id="account-recovery-create-email-description"
			>
				<Typography />
			</Localized>
		</CardContent>
		<CardContent sx={{ borderTop: '1px #c4c4c4 solid' }}>
			<Stack direction="row" justifyContent="center" spacing={2}>
				<Localized id="account-recovery-create-cancel-button">
					<Button
						onClick={() => navigate(-1)}
					/>
				</Localized>
				<Localized id="account-recovery-create-submit-button">
					<Button
						type="submit"
						disabled={props.pending || !props.onSubmit}
						variant="contained"
					/>
				</Localized>
			</Stack>
		</CardContent>
	</FormScreen>
}

interface FormFeedbackProps {
	feedback: Feedback;
}

function formFeedbackMsg(feedback: Feedback): {stringID: string, severity: "error" | "success"} {
	switch (feedback) {
		case Feedback.RejectedBug:
			return {
				stringID: "account-recovery-create-feedback-bug",
				severity: "error",
			};
		case Feedback.RejectedNetwork:
			return {
				stringID: "account-recovery-create-feedback-network",
				severity: "error",
			};
		case Feedback.RejectedInvalidEmail:
			return {
				stringID: "account-recovery-create-feedback-invalid-email",
				severity: "error",
			};
		case Feedback.Accepted:
			return {
				stringID: "account-recovery-create-feedback-success",
				severity: "success",
			};
	}
}

function FormFeedback(props: FormFeedbackProps) {
	const response = formFeedbackMsg(props.feedback);

	return (
		<Localized id={response.stringID}>
			<Alert severity={response.severity} />
		</Localized>
	);
}
